exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".page-quotes__categories-item{display:inline-block;padding:.5em;font-family:FranklinGothicDemi;cursor:pointer;border:1px solid #e96661;border-right:none}.page-quotes__categories-item:last-child{border-right:1px solid #e96661}.page-quotes__categories-item--active{background-color:#e96661;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-51238f9d","scoped":false,"hasInlineConfig":false}!./~/stylus-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/page-quotes.vue
// module id = 61
// module chunks = 0